/* eslint-disable react/self-closing-comp */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { FiLock, FiUser } from 'react-icons/fi';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { useLoader } from '../../hooks/loader';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import logo from '../../assets/Marca_Transfácil_sem tagline branca.png';
import getValidationErrors from '../../utils/getValidationErrors';

import {
  Company,
  Container,
  Content,
  Forgot,
  Header,
  Logo,
  Register,
} from './styles';
import ModalResetPassword from './Components/ModalResetPassword';

const Login: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const { isActive, changeLoader } = useLoader();
  const [modalResetPassword, setModalResetPassword] = useState(false);
  const schema = Yup.object().shape({
    username: Yup.string().required('Login é obrigatório'),
    password: Yup.string().required('Senha é obrigatória'),
  });

  const openModalResetPassword = () => {
    setModalResetPassword(true);
  };

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});
        changeLoader(true);

        await schema.validate(data, {
          abortEarly: false,
        });

        const { username, password } = data;

        await signIn({ username, password });
        localStorage.removeItem('DataFilter');

        changeLoader(false);
      } catch (err: any) {
        changeLoader(false);
        const { ...error } = err;

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        if (error?.response?.data?.detail) {
          addToast({
            type: 'error',
            title: 'Ocorreu um erro ao realizar o Login',
            description: `${error?.response?.data?.detail}`,
          });
        } else {
          addToast({
            type: 'error',
            title:
              'Serviço Temporariamente indisponível, por favor verifique mais tarde',
          });
        }
      }
    },
    [schema, addToast, signIn, changeLoader],
  );

  return (
    <Container>
      {isActive && <Loader />}
      <Content>
        <Header>s</Header>

        <Logo>
          <a href="https://transfacil.com.br">
            <img src={logo} alt="Transfacil" />
          </a>
        </Logo>

        <Form ref={formRef} onSubmit={handleSubmit}>
          <Input
            id="username"
            name="username"
            icon={FiUser}
            className="login"
            placeholder="Login"
            schema={schema}
          />
          <Input
            id="password"
            name="password"
            icon={FiLock}
            className="password"
            type="password"
            placeholder="Senha"
            schema={schema}
          />
          <Forgot>
            <button type="button" onClick={openModalResetPassword}>
              <strong> Esqueceu a senha?</strong>
            </button>
          </Forgot>

          <Button color="orange" padding="5" type="submit" className="entrar">
            Entrar
          </Button>
          <span className="Voltar" style={{ textAlign: 'center' }}>
            <a href="https://transfacil.com.br/">
              <button
                style={{ fontSize: '18px', backgroundColor: 'transparent' }}
                type="button"
              >
                <strong>Voltar</strong>
              </button>
            </a>
          </span>
        </Form>
        <Register>
          <p>
            <strong>Não tem conta?</strong>
            <strong>
              <a
                style={{ color: 'var(--orange)' }}
                href="https://transfacil.com.br/para-empresas"
                target="blank"
              >
                Cadastrar
              </a>
            </strong>
          </p>
        </Register>
        <Company>
          <p>
            <strong>Pessoa Fisíca?</strong>
          </p>
          <span>
            <a href="https://transfacil.com.br/" target="blank">
              <button type="button">
                <strong style={{ color: 'var(--orange)' }}>
                  Acesse o Transfácil
                </strong>
              </button>
            </a>
          </span>
        </Company>
      </Content>

      {modalResetPassword && (
        <ModalResetPassword
          title="Esqueceu sua senha?"
          show={modalResetPassword}
          text="Digite o ID numérico do titular e você receberá no email cadastrado instruções."
          handleClose={() => setModalResetPassword(false)}
        />
      )}
    </Container>
  );
};

export default Login;
